import React, { useState } from 'react';
import { PlayIcon } from 'lucide-react';
import { bclCoverImage, bclVideoUrl } from '../../data/diamond';
export function BclPlayer() {
  const [playing, setPlaying] = useState(false);
  const embed = getEmbed(bclVideoUrl);
  return <div className="relative aspect-video w-full overflow-hidden rounded-xl border border-white/10 bg-black" data-id="element-12" data-mp="2sa9tbjey1x86">
      {playing && embed ? embed.type === 'iframe' ? <iframe src={embed.src} title="JSEEFECT Diamond Method" allow="autoplay; fullscreen; picture-in-picture; encrypted-media" allowFullScreen className="absolute inset-0 h-full w-full" data-id="element-13" data-mp="3kye0yah2skdi" /> : <video src={embed.src} autoPlay controls playsInline className="absolute inset-0 h-full w-full bg-black" data-id="element-14" data-mp="3g5kw7mllxc1f" /> : <button type="button" onClick={() => setPlaying(true)} aria-label="Reproducir video" className="group absolute inset-0 h-full w-full focus-visible:outline-none" data-id="element-15" data-mp="7p9mkjzwu2go">
          <img src={bclCoverImage} alt="" className="absolute inset-0 h-full w-full object-cover" data-id="element-16" data-mp="2lmzl0b2quhg6" />
          <span className="absolute inset-0 bg-black/20" aria-hidden="true" data-id="element-17" data-mp="2hlxm5vcqo7eq" />
          <span className="absolute left-1/2 top-1/2 flex h-16 w-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-crimson text-white shadow-[0_0_0_10px_rgba(185,28,43,0.18)] transition-[transform,background-color] duration-200 ease-out group-hover:scale-105 group-hover:bg-crimson-hover group-active:scale-95 group-focus-visible:ring-2 group-focus-visible:ring-white sm:h-20 sm:w-20" data-id="element-18" data-mp="2vgghxny6gco2">
            <PlayIcon className="ml-1 h-6 w-6 fill-white sm:h-7 sm:w-7" aria-hidden="true" data-id="element-19" data-mp="3ebnegtxncd4t" />
          </span>
          {playing && !embed && <span className="absolute inset-x-0 bottom-5 text-center text-xs tracking-[0.2em] text-white/70" data-id="element-20" data-mp="1jz71laaci0qz">
              VIDEO DISPONIBLE PRONTO
            </span>}
        </button>}
    </div>;
}
function getEmbed(url: string): {
  type: 'iframe' | 'video';
  src: string;
} | null {
  if (!url) return null;
  const yt = url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/|shorts\/)|youtu\.be\/)([\w-]{11})/);
  if (yt) return {
    type: 'iframe',
    src: `https://www.youtube.com/embed/${yt[1]}?autoplay=1&rel=0&modestbranding=1`
  };
  const vimeo = url.match(/vimeo\.com\/(?:video\/)?(\d+)/);
  if (vimeo) return {
    type: 'iframe',
    src: `https://player.vimeo.com/video/${vimeo[1]}?autoplay=1`
  };
  return {
    type: 'video',
    src: url
  };
}